const header = document.querySelectorAll<HTMLElement>(`header`)[0];
const headerSubEyebrow = document.querySelectorAll<HTMLElement>(`header .header-top + .eyebrow-content`)[0]; 
const footerAlerts = document.querySelectorAll<HTMLElement>(`footer .footer-alerts`)[0];
const body = document.querySelectorAll<HTMLElement>(`body`)[0];
const pageNavigation = document.querySelectorAll<HTMLElement>(`.page-component.page-navigation`)[0];
const utilityNavigationMobile = document.getElementById('utility-navigation-mobile');
var scrollOffsetTimeout;

function recalculateScrollOffset(): void {

  if (header && body) {
    var headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
  }
  if (headerSubEyebrow && body) {
    var headerSubEyebrowHeight = headerSubEyebrow.offsetHeight;
    document.documentElement.style.setProperty("--header-sub-eyebrow-height", `${headerSubEyebrowHeight}px`);
  }
  if (pageNavigation && body) {
    var pageNavigationHeight = pageNavigation.offsetHeight;
    document.documentElement.style.setProperty("--page-navigation-height", `${pageNavigationHeight}px`);
  }
  if (footerAlerts) {
    var footerAlertsHeight = footerAlerts.offsetHeight;
    document.documentElement.style.setProperty("--footer-alerts-height", `${footerAlertsHeight}px`);
  }
  if (utilityNavigationMobile) {
    var utilityNavigationOffsetLeft = utilityNavigationMobile.getBoundingClientRect().left;
    document.documentElement.style.setProperty("--utility-navigation-offset-left", `${utilityNavigationOffsetLeft}px`);
  }
}


function delayRecalculateScrollOffset(): void {
    clearTimeout(scrollOffsetTimeout);
    scrollOffsetTimeout = setTimeout(function() {
        recalculateScrollOffset();
    }, 500);
}


// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  recalculateScrollOffset();
});

// Delayed run on resize
window.addEventListener('resize', () => {
  delayRecalculateScrollOffset();
});

// Delayed run on header & footer alerts DOM changes
let headerObserver = new MutationObserver(() => {
    delayRecalculateScrollOffset();
});
if (header) {
  headerObserver.observe(header, {
    characterDataOldValue: true,
    subtree: true,
    childList: true,
    characterData: true
  });
}
if (footerAlerts) {
  headerObserver.observe(footerAlerts, {
    characterDataOldValue: true,
    subtree: true,
    childList: true,
    characterData: true
  });
}
